export const WEB_PORTAL_DESCRIPTION_RE = /web\s*portal/i;

export const descriptionLooksLikeWebPortal = (description) =>
  WEB_PORTAL_DESCRIPTION_RE.test(String(description || ''));

export const formatAllocationAmount = (value) =>
  `$${(Number(value) || 0).toFixed(2)}`;
